import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { environment } from 'environments/environment';

@Injectable()
export class Intermv2Service {

  constructor(private http:Http) { }

  usuario(id: number){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/afiliacion/validacion/${id}`;

    return this.http.get(url, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  validarCodigo(body: any){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/intermediario/validarCodigo`;

    return this.http.post(url, body, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  inscribirInt(body: any){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/afiliacion/registro`;

    return this.http.post(url, body, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  tipoDocumento(){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/general/tipoDocumento`;

    return this.http.get(url, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  comoSeEntero(){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/intermediario/comoSeEntero`;

    return this.http.get(url, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  bancos(){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/general/bancos`;

    return this.http.get(url, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  paises(){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/general/paises`;

    return this.http.get(url, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  departamentos(idPais: number){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/general/departamentos/${idPais}`;

    return this.http.get(url, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  ciudades(idDepartamento: number){
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url = `${environment.apiIntermv2}/general/ciudades/${idDepartamento}`;

    return this.http.get(url, {headers: headers}).toPromise().then(response => {
      return response.json() as any;
    }).catch(this.handleError)
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); //
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/general/intermv2.service.ts